import React, { Component, lazy, Suspense } from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
//import PageLoading from "HLASReactComponents/loaders/PageLoading";
import PageLoading from 'components/loaders/PageLoading';
import SpinToWinNew from './SpinToWinNew';
import axios from 'axios';

// To set Global Token for request
axios.interceptors.request.use(
  function (config) {

    // withCredentialsForce | added to control axios credentials	

    if ('withCredentialsForce' in config) {
      config.withCredentials = config.withCredentialsForce;
    } else {
      config.withCredentials = true;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


const Debug = (
  lazy(() => (
    // import('modules/application/manage/CIP/App')
    import(/* webpackChunkName: "Debug" */ 'modules/debug/App')
  ))
)

// const User = (
//   lazy(() => (
//     import(/* webpackChunkName: "User" */ './modules/User/App')
//   ))
// )

const Prestige = (
  lazy(() => (
    import(/* webpackChunkName: "Prestige" */ './PrestigeProgram/App')
  ))
)

const CepProgram = (
  lazy(() => (
    import(/* webpackChunkName: "Prestige" */ './CepProgram/App')
  ))
)

const PartnerProgram = (
  lazy(() => (
    import(/* webpackChunkName: "PartnerProgram" */ './partnerProgram/App')
  ))
)

const Touristcard = (
  lazy(() => (
    import(/* webpackChunkName: "Touristcard" */ './modules/touristcard/App')
  ))
)

// const FlashPayShield = (
//   lazy(() => (
//     import(/* webpackChunkName: "FlashPayShield" */ './modules/flashpayshield/App')
//   ))
// )

const FlashPayShieldWithUpgrade = (
  lazy(() => (
    import(/* webpackChunkName: "FlashPayShieldWithUpgrade" */ './modules/FlashPayShieldWithUpgrade/App')
  ))
)

const SimplyGo = (
  lazy(() => (
    import(/* webpackChunkName: "SimplyGo" */ './modules/SimplyGo/App')
  ))
)


const MotoringCardShieldWithUpgrade = (
  lazy(() => (
    import(/* webpackChunkName: "MotoringCardShieldWithUpgrade" */ './modules/MotoringCardShieldWithUpgrade/App')
  ))
)
const FamilyProtectLiteWithUpgrade = (
  lazy(() => (
    import(/* webpackChunkName: "FamilyProtectLiteWithUpgrade" */ './modules/FamilyProtectLiteWithUpgrade/App')
  ))
)

const vCashCard = (
  lazy(() => (
    import(/* webpackChunkName: "vCashCard" */ './modules/vcashcard/App')
  ))
)


const Maid = (
  lazy(() => (
    import(/* webpackChunkName: "MaidProtect360" */ './modules/maid/newpurchase/App')
  ))
)

const MaidRenewal = (
  lazy(() => (
    import(/* webpackChunkName: "MaidProtect360" */ './modules/maid/renewal/App')
  ))
)

const LoanProtect360Renewal = (
  lazy(() => (
    import(/* webpackChunkName: "Loan Protect 360 Renewal" */ 'modules/LoanProtect360/views/renewal/App')
  ))
)

const StatementofAccount = (
  lazy(() => (
    import(/* webpackChunkName: "SOA" */ './modules/soa/pages/soa')
  ))
)

const CommissionStatement = (
  lazy(() => (
    import(/* webpackChunkName: "CommissionStatement" */ './modules/commissionstatement/pages/cs')
  ))
)

const TravelProtect360 = (
  lazy(() => (
    import(/* webpackChunkName: "TravelProtect360" */ './modules/travelprotect360/App')
  ))
)

const TravelProtect360Plus = (
  lazy(() => (
    import(/* webpackChunkName: "TravelProtect360Plus" */ './modules/TravelProtect360Plus/App')
  ))
)

const AxsTravelInsure = (
  lazy(() => (
    import(/* webpackChunkName: "AxsTravelInsure" */ './modules/AxsTravelInsure/App')
  ))
)

const ContactUs = (
  lazy(() => (
    import(/* webpackChunkName: "ContactUs" */ './modules/contactus/App')
  ))
)

const ReviewUs = (
  lazy(() => (
    import(/* webpackChunkName: "ReviewUs" */ './modules/reviewus/App')
  ))
)

const CarProtect360 = (
  lazy(() => (
    import(/* webpackChunkName: "CarProtect360" */ './modules/CarProtect360/App')
  ))
)

const CarProtect360Renewal = (
  lazy(() => (
    import(/* webpackChunkName: "MaidProtect360" */ './modules/CarProtect360/renewal/App')
  ))
)

const MotorShow = (
  lazy(() => (
    import(/* webpackChunkName: "Motorshow2020" */ './modules/motorshow2020/App')
  ))
)

const Family = (
  lazy(
    () => (import(
      /* webpackChunkName: "FamilyProtect360" */ './modules/family/App'
    ))
  )
)

const FraudProtect360Plus = (
  lazy(
    () => (import(
      /* webpackChunkName: "FraudProtect360" */ './modules/FraudProtect360/App'
    ))
  )
)

const ChoicesProtect360 = (
  lazy(
    () => (import(
      /* webpackChunkName: "ChoicesProtect360" */ './modules/ChoicesProtect360/newpurchase/App'
    ))
  )
)



const HIProtect360 = (
  lazy(
    () => (import(
      /* webpackChunkName: "HIProtect360Protect360" */ './modules/HIProtect360/App'
    ))
  )
)


const CILeadForm = (
  lazy(() => (
    import(/* webpackChunkName: "CILeadForm" */ './modules/ci_leadform/App')
  ))
)


// const hlBankTravelKit = (
//   lazy(() => (
//     import(/* webpackChunkName: "HLBankTravelKit" */ './modules/hlbanktravelkit/App')
//   ))
// )

// const hlBankCasa = (
//   lazy(() => (
//     import(/* webpackChunkName: "HLBankCasa" */ './modules/hlbankcasa/App')
//   ))
// )

const PowerAgentPortal = (
  lazy(() => (
    import(/* webpackChunkName: "PowerAgentPortal" */ './modules/PowerAgentPortal/App')
  ))
)



const FilipinoBond = (
  lazy(() => (
    import(/* webpackChunkName: "FilipinoBond" */ './modules/filipinobond/App')
  ))
)

const HomeProtect = (
  lazy(() => (
    import(/* webpackChunkName: "HomeProtect360" */ './modules/homeprotect360/newpurchase/App')
  ))
)

const HomeProtectLite = (
  lazy(() => (
    import(/* webpackChunkName: "HomeProtectLite" */ './modules/homeprotectlite/newpurchase/App')
  ))
)

const PublicHousingAssured = (
  lazy(() => (
    import(/* webpackChunkName: "PublicHousingAssured" */ './modules/PublicHousingAssured/newpurchase/App')
  ))
)

const HomeSafeOnline = (
  lazy(() => (
    import(/* webpackChunkName: "HomeSafe" */ './modules/homesafe/newpurchase/App')
  ))
)

const PhoneProtect = (
  lazy(() => (
    import(/* webpackChunkName: "PhoneProtect360" */ './modules/phoneprotect360/newpurchase/App')
  ))
)

const TravelAssured = (
  lazy(() => (
    import(/* webpackChunkName: "TravelAssured" */ './modules/TravelAssured/App')
  ))
)

const CurrencyConverter = (
  lazy(() => (
    import(/* webpackChunkName: "currencyconverter" */ './modules/CurrencyConverter/App')
  ))
)

const weatherforecast = (
  lazy(() => (
    import(/* webpackChunkName: "weather" */ 'modules/WeatherForecast/App')
  ))
);

/* CI Products */

const ErrorPage = (
  lazy(() => (
    import( /* webpackChunkName: "Common.Error" */  'modules/common/views/ErrorPage')
  ))
)

const CIProtect360Dashboard = (
  lazy(() => (
    // import('modules/application/manage/CIP/App')
    import(/* webpackChunkName: "CIProtect360.Dashboard" */ 'modules/CIProtect360/views/dashboard/App')
  ))
)

const CIProtect360AppDetails = (
  lazy(() => (
    // import('modules/application/create/CIP/App')
    import(/* webpackChunkName: "CIProtect360.Details" */ 'modules/CIProtect360/views/detail/App')
  ))
)

const CIProtect360Generate = (
  lazy(() => (
    import(/* webpackChunkName: "CIProtect360.Generate" */ 'modules/CIProtect360/views/generate/App')
  ))
);

const KeymanProtect360Generate = (
  lazy(() => (
    import(/* webpackChunkName: "KeymanProtect360" */ 'modules/KeymanProtect360/views/generate/App')
  ))
);

const KeymanProtect360Dashboard = (
  lazy(() => (
    import(/* webpackChunkName: "KeymanProtect360.Dashboard" */ 'modules/KeymanProtect360/views/dashboard/App')
  ))
);

const KeymanProtect360AppDetails = (
  lazy(() => (
    // import('modules/application/create/CIP/App')
    import(/* webpackChunkName: "KeymanProtect360.Details" */ 'modules/KeymanProtect360/views/detail/App')
  ))
)

const AppPayment = (
  lazy(() => (
    import(/* webpackChunkName: "AppPayment" */ 'modules/payment/views/payment/App')
  ))
)

const AppPaymentProcessing = (
  lazy(() => (
    import(/* webpackChunkName: "AppPaymentProcessing" */ 'modules/payment/views/processing/App')
  ))
)

const AppPaymentComplete = (
  lazy(() => (
    import( /* webpackChunkName: "AppPaymentComplete" */ 'modules/payment/views/complete/App')
  ))
)

const App2DPaymentComplete = (
  lazy(() => (
    import( /* webpackChunkName: "App2DPaymentComplete" */ 'modules/payment/views/2DComplete/App')
  ))
)

const CIPDirectGenerate = (
  lazy(() => (
    import(/* webpackChunkName: "CIProtect360.Direct.Generate" */ 'modules/CIDirect/views/generate/App')
  ))
);

// const EarlyProtect360 = (
//   lazy(() => (
//     import(/* webpackChunkName: "EarlyProtect360" */ 'modules/earlyprotect360/views/generate/App')
//   ))
// );
const EMAPortal = (
  lazy(() => (
    import(/* webpackChunkName: "EMAPortal" */ './modules/EMAPortal/App')
  ))
)

const HomeStarterKit = (
  lazy(() => (
    import(/* webpackChunkName: "HomeStarterKit" */ './modules/homestarterkit/App')
  ))
)

const FreeHomeInsurance = (
  lazy(() => (
    import(/* webpackChunkName: "freehomeinsurance" */ './modules/freehomeinsurance/App')
  ))
)

// const EarlyProtect360Dashboard = (
//   lazy(() => (
//     import(/* webpackChunkName: "EarlyProtect360.Dashboard" */ 'modules/earlyprotect360/views/dashboard/App')
//   ))
// )

// const EarlyProtect360AppDetails = (
//   lazy(() => (
//     import(/* webpackChunkName: "EarlyProtect360.Details" */ 'modules/earlyprotect360/views/detail/App')
//   ))
// )

const LeadForm = (
  lazy(() => (
    import(/* webpackChunkName: "LeadForm" */ 'modules/lead_form/App')
  ))
)

const CampaignLeadForm = (
  lazy(() => (
    import(/* webpackChunkName: "CampaignLeadForm" */ './modules/campaign_lead/App')
  ))
)

const CashCardShield = (
  lazy(() => (
    import(/* webpackChunkName: "CashCardShield" */ './modules/cashcard_shield/App')
  ))
)

const LoanProtect360 = (
  lazy(() => (
    import(/* webpackChunkName: "LoanProtect360" */ 'modules/LoanProtect360/views/generate/App')
  ))
);

const LoanProtect360Dashboard = (
  lazy(() => (
    import(/* webpackChunkName: "LoanProtect360.Dashboard" */ 'modules/LoanProtect360/views/dashboard/App')
  ))
)

const LoanProtect360AppDetails = (
  lazy(() => (
    import(/* webpackChunkName: "LoanProtect360.Details" */ 'modules/LoanProtect360/views/detail/App')
  ))
)

const ComplimentaryHomeContents = (
  lazy(() => (
    import(/* webpackChunkName: "ComplimentaryHomeContents" */ './modules/ComplimentaryHomeContents/App')
  ))
)

const BusinessProtect360 = (
  lazy(() => (
    import(/* webpackChunkName: "BusinessProtect360.Generate" */ 'modules/BusinessProtect360/newpurchase/App')
  ))
);

const InternalDemoCookie = (
  lazy(() => (
    import(/* webpackChunkName: "InternalDemoCookie" */ 'modules/InternalDemo/App')
  ))
);

const SingaporeTravelPass = (
  lazy(() => (
    import(/* webpackChunkName: "SingaporeTravelPass" */ './modules/SingaporeTravelPass/App')
  ))
);

const ConsumerPortal = (
  lazy(() => (
    import(/* webpackChunkName: "ConsumerPortal" */ './modules/ConsumerPortal/App')
  ))
);

const EarlyProtect360PlusDashboard = (
  lazy(() => (
    import(/* webpackChunkName: "EarlyProtect360Plus.Dashboard" */ 'modules/EarlyProtect360Plus/views/dashboard/App')
  ))
)

const EarlyProtect360PlusAppDetails = (
  lazy(() => (
    import(/* webpackChunkName: "EarlyProtect360Plus.Details" */ 'modules/EarlyProtect360Plus/views/detail/App')
  ))
)

const EarlyProtect360Plus = (
  lazy(() => (
    import(/* webpackChunkName: "EarlyProtect360Plus" */ 'modules/EarlyProtect360Plus/views/generate/App')
  ))
);

const CorporateTravel = (
  lazy(() => (
    import(/* webpackChunkName: "CorporateTravel" */ './modules/CorporateTravel/App')
  ))
)

const TransferProtect360Pro = (
  lazy(() => (
    import(/* webpackChunkName: "transferprotect360pro" */ './modules/transferprotect360pro/App')
  ))
)

const TravelAssuredPlus = (
  lazy(() => (
    import(/* webpackChunkName: "TravelAssuredPlus" */ './modules/TravelAssuredPlus/App')
  ))
)

const MyInfoCallback = (
  lazy(() => (
    import( /* webpackChunkName: "Common.MyInfoCallback" */  'modules/common/views/MyInfoCallback')
  ))
)

const SBSTTravelInsurance = (
  lazy(() => (
    import( /* webpackChunkName: "SBSTTravelInsurance" */  './modules/sbs/travel-coverage/App')
  ))
)

const SBSTPAProtectLite = (
  lazy(() => (
    import( /* webpackChunkName: "SBSTPAProtectLite" */  './modules/sbs/pa-lite/App')
  ))
)

const SBSTPAProtectPlus = (
  lazy(() => (
    import( /* webpackChunkName: "SBSTPAProtectPlus" */  './modules/sbs/pa-plus/App')
  ))
)


class Bootstrapper extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={<PageLoading />}>
          <Switch>
            {
              process.env.NODE_ENV !== 'production' &&
              <Route path="/debug" component={Debug} />
            }
            {/* {
              process.env.NODE_ENV !== 'production' &&
              <Route path="/caltex" component={Caltex} />
            } */}
            {/* Consumer Website Login */}
            <Route path="/consumer" component={ConsumerPortal} />
            {/* <Route path="/consumer/login" component={ConsumerPortal} />
            <Route path="/consumer/dashboard" component={ConsumerPortal} /> */}

            {/* <Route path="/user" component={User} /> */}

            {/* <Route path="/prestige" component={Prestige} /> */}
            <Route exact path="/prestige/signin" render={() => <Redirect to={{ pathname: "/consumer/login" }} />} />

            <Route path="/CEP" component={CepProgram} />
            <Route path="/elite-member-program" component={PartnerProgram} />
            <Route path="/tourist-protect360" component={Touristcard} />
            <Route path="/review-us" component={ReviewUs} />

            <Route exact path="/maid-protect360" render={() => <Redirect to={{ pathname: "/maid-protect360-pro" }} />} />
            <Route exact path="/enhanced-maid-protect360" render={() => <Redirect to={{ pathname: "/maid-protect360-pro" }} />} />
            <Route path="/maid-protect360-pro" component={Maid} />

            <Route exact path="/maid-protect360-renewal" render={() => <Redirect to={{ pathname: "/maid-protect360-pro-renewal" }} />} />
            <Route exact path="/enhanced-maid-protect360-renewal" render={() => <Redirect to={{ pathname: "/maid-protect360-pro-renewal" }} />} />
            <Route path="/maid-protect360-pro-renewal" component={MaidRenewal} />

            <Route path="/car-protect360" component={CarProtect360} />
            <Route path="/car-protect360-renewal" component={CarProtect360Renewal} />
            <Route path="/partner/account/statement" component={StatementofAccount} />
            {/* <Route path="/travel-protect360" component={TravelProtect360} /> */}
            <Route path="/covid-safe-travel" render={() => <Redirect to={{ pathname: "/travel-protect360" }} />}/>
            <Route path="/travel-protect360" component={TravelProtect360Plus} />
            <Route path="/axs-travel-insure" component={AxsTravelInsure} />
            
            <Route path="/partner/account/commissionstatement" component={CommissionStatement} />
            <Route path="/motor-show-2020" component={MotorShow} />
            <Route path="/family-protect360" component={Family} />
            <Route path="/hospital-protect360" component={HIProtect360} />
            <Route path="/ci_leadform" component={CILeadForm} />
            {/* <Route path="/hlbank/travelkit" component={hlBankTravelKit} /> */}
            {/* <Route path="/hlbank/casa" component={hlBankCasa} /> */}
            <Route path="/partner/logout" component={PowerAgentPortal} />
            <Route path="/partner/login" component={PowerAgentPortal} />
            <Route path="/partner/old-login" component={PowerAgentPortal} />
            <Route path="/partner/dashboard" component={PowerAgentPortal} />
            <Route path="/partner/reset-password" component={PowerAgentPortal} />
            <Route path="/partner/car-renewal-listing" component={PowerAgentPortal} />
            <Route path="/partner/maid-renewal-listing" component={PowerAgentPortal} />

            <Route path="/filipino-bond" component={FilipinoBond} />
            <Route path="/home-protect360" component={HomeProtect} />

            <Route path="/home-protectlite" component={HomeProtectLite} />
            <Route path="/home-assuredlite" component={HomeProtectLite} />

            <Route path="/homesafeonline" component={HomeSafeOnline} />
            <Route path="/contactus" component={ContactUs} />
            <Route path="/phone-protect360" component={PhoneProtect} />
            {/* The intent is to redirect the existing URL to the new one */}
            {/* REMOVED 03/07/2024 - <Route path="/travel-assured" component={TravelProtect360Plus} /> */}
            <Route path="/travel-assured" render={() =>
            (
              <Redirect to="/travel-assured-plus" />
            )} />
            <Route path="/travel-assured-plus" component={TravelAssuredPlus} />
            <Route path="/ema" component={EMAPortal} />

            {/** Common */}
            <Route path="/error" component={ErrorPage} />

            {/** CI Protect360 */}
            <Route path="/partner/cip/dashboard" component={CIProtect360Dashboard} />
            <Route path="/partner/cip/detail/" component={CIProtect360AppDetails} />
            <Route path="/ci-protect360/generate" component={CIProtect360Generate} />

            {/** CI Direct */}
            <Route path="/ci-protect360/direct" component={CIPDirectGenerate} />

            {/** Early Protect360 -- Disabled 29-FEB-2024 requested by UW/CHEW MING/
            <Route path="/partner/eii/dashboard" component={EarlyProtect360Dashboard} / >
            <Route path="/partner/eii/detail/" component={EarlyProtect360AppDetails} />
            <Route path="/early-protect360" component={EarlyProtect360} / >
            */}


            {/** Early Protect360 Plus */}
            <Route path="/partner/epi/dashboard" component={EarlyProtect360PlusDashboard} />
            <Route path="/partner/epi/detail/" component={EarlyProtect360PlusAppDetails} />
            <Route path="/early-protect360-plus" component={EarlyProtect360Plus} />

            {/** Car Loan Protector */}
            <Route path="/partner/loanprotect360/dashboard" component={LoanProtect360Dashboard} />
            <Route path="/partner/loanprotect360/detail/" component={LoanProtect360AppDetails} />
            <Route path="/loan-protect360" component={LoanProtect360} />
            <Route path="/loan-protect360-renewal" component={LoanProtect360Renewal} />

            {/** Keyman Protect360 - REMOVED AS OF 28/06/2024 */}
            {/* <Route path="/keyman-protect360" component={KeymanProtect360Generate} />
            <Route path="/partner/key/dashboard" component={KeymanProtect360Dashboard} />
            <Route path="/partner/key/detail/" component={KeymanProtect360AppDetails} /> */}

            {/** Payment */}
            <Route path="/application/payment" component={AppPayment} />
            <Route path="/payment/processing" component={AppPaymentProcessing} />
            <Route path="/payment/complete" component={AppPaymentComplete} />
            <Route path="/payment/2D/complete" component={App2DPaymentComplete} />
            

            <Route path="/lead-form" component={LeadForm} />
            <Route path="/caltex" component={LeadForm} />
            <Route path="/christmas-spin-2020" component={CampaignLeadForm} />
            <Route path="/hlas-mobile-spin" component={CampaignLeadForm} />
            <Route path="/spin-to-win" component={SpinToWinNew} />
            {/* <Route path="/spin-to-win-new" component={SpinToWinNew} /> */}
            <Route path="/hlas-collab-geneco" component={CampaignLeadForm} />
            
            <Route path="/hl-ez-protect-lite" component={SimplyGo} />

            {/** related with NETS */}
            {/* <Route path="/nets-flashpay-shield" component={FlashPayShield} /> */}
            <Route path="/nets-flashpay-shield" component={FlashPayShieldWithUpgrade} />
            <Route path="/nets-motoring-card-shield" component={MotoringCardShieldWithUpgrade} />
            <Route path="/nets-vcashcard" component={vCashCard} />
            <Route path="/nets-cashcard-shield" component={CashCardShield} />
            <Route path="/nets-family-protectlite" component={FamilyProtectLiteWithUpgrade} />

            {/** Complimentary Home and Upgrade HomeSafe option */}
            <Route path="/home-starter-kit" component={HomeStarterKit} />
            <Route path="/free-home-insurance" component={FreeHomeInsurance} />

            {/** Complimentary Home and Upgrade Home Protect360 option */}
            <Route path="/senoko" component={ComplimentaryHomeContents} />
            <Route path="/union-power" component={ComplimentaryHomeContents} />
            <Route path="/servishero" component={ComplimentaryHomeContents} />
            <Route path="/hlbfreehome" component={ComplimentaryHomeContents} />
            <Route path="/philipsfreehome" component={ComplimentaryHomeContents} />
            <Route path="/caltexfreehome" exact component={ComplimentaryHomeContents} />
            <Route path="/caltexfreehome/:name" component={ComplimentaryHomeContents} />
            <Route path="/geneco" component={ComplimentaryHomeContents} />
            <Route path="/ez-link" component={ComplimentaryHomeContents} />

            {/** Business Protect360 */}
            <Route path="/business-protect360" component={BusinessProtect360} />

            {/** Partners' Commercial Section */}
            <Route path="/partner/commercial/dashboard" component={PowerAgentPortal} />

            <Route path="/partner/internal-demo-cookie" component={InternalDemoCookie} />
            {/** Singapore Travel Pass */}
            <Route path="/singapore-travel-pass" component={SingaporeTravelPass} />

            {/** Currency Converter */}
            <Route path="/currency-converter" component={CurrencyConverter} />


            {/** Weather-Forecast */}
            <Route path="/weather-forecast" component={weatherforecast} />

            {/** Public Housing Assured */}
            <Route path="/public-housing-assured" component={PublicHousingAssured} />

            <Route path="/corporate-travel360" component={CorporateTravel} />

            {/**Transfer Protect 360 Pro */}
            <Route path="/transfer-protect360-pro" component={TransferProtect360Pro} />

            {/**Fraud Protect 360 Pro */}
            <Route path="/fraud-protect360-plus" component={FraudProtect360Plus} />

            {/**HLAS Protect 360 Pro */}
            <Route path="/choice-protect360" component={ChoicesProtect360} />
            
            <Route exact path="/sginfo/callback" component={MyInfoCallback} />
             
            <Route path="/hlst-travel-insurance" component={SBSTTravelInsurance} />
            <Route path="/hlst-pa-free" component={SBSTPAProtectLite} />
            <Route path="/hlst-pa-upgrade" component={SBSTPAProtectPlus} />
          </Switch>

        </Suspense>
      </BrowserRouter>

    );
  }
}

export default Bootstrapper;
